// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
// import { ViewCell } from 'ng2-smart-table';
import { Model } from './common/.base.model';
import { Author } from './author';
import { Department } from './department';
import { Application } from './application';
import { title } from 'process';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface';

export interface JobPosting extends Model {
  title: string;
  department: Department;
  description: string;
  requirements: string;
  location: string;
  type: string;
  postingStatus: string;
  publishDate: string;
  closingDate: Date;
  applications: Application;
  link: string;
}

export const JobPostingConfig: EntityConfigTemplate = {
  meta: { entityName: 'job-posting', entityPluralName: 'job-postings', titleField: 'title', view: false },
  title: { title: 'Title' },
  department: { isForeignKey: true, title: 'Department', valuePrep: (_cell_, row) => `${row?.department?.name ?? ''}` },
  description: { title: 'Description' },
  requirements: { title: 'Requirements' },
  location: { title: 'Location' },
  type: { title: 'Type' },
  link: { title: 'Posting Link', view: {list: false}, default: (record) => `https://mira-hr.com/jobs/${record.documentId}`},
  postingStatus: { title: 'Posting Status' },
  publishDate: { title: 'Publish Date', type: 'date' },
  closingDate: { title: 'Closing Date', type: 'date' },
  applications: { isForeignKey: true, title: 'Applications', valuePrep: (_cell_, row) => `${row?.applications?.length | 0}` },
};

const statusOptions = [
  { value: 'draft', label: 'Draft'},
  { value: 'open', label: 'Open'},
  { value: 'closed', label: 'Closed'}
]

const typeOptions = [
  { value: 'internal', label: 'Internal'},
  { value: 'external', label: 'External'},
  { value: 'both', label: 'Internal and External'}
]

export const JobPostingFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: "Job Posting",
      columns: [
        {
          size: "col-12",
          type: "form",
          sections: [
            {
              title: "Position",
              rows: [
                {
                  fields: [
                    { name: "title", label: "Title", type: "text", required: true, size: "col-6" },
                    { name: "department", label: "Department", type: "selectRelation", entityName: "department", size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "location", label: "Location", type: "text", required: false, size: "col-6" },
                    { name: "link", label: "Posting Link", type: "text", disabled: true, required: false, size: "col-6" },
                  ]
                },
              ]
            },
            {
              title: "Availability",
              rows: [
                {
                  fields: [
                    { name: "postingStatus", label: "Posting Status", type: "select", options: statusOptions, required: false, size: "col-6" },
                    { name: "type", label: "Type", type: "select", options: typeOptions, required: false, size: "col-6" },  
                  ]
                },
                {
                  fields: [
                    { name: "publishDate", label: "Publish Date", type: "date", required: false, size: "col-6" },  
                    { name: "closingDate", label: "Closing Date", type: "date", required: false, size: "col-6" },
                  ] 
                },
              ]
            },
            {
              title: 'Job Description',
              rows: [
                {
                  fields: [
                    { name: "description", label: "Description", type: "textarea", required: false, size: "col-12" },
                    { name: "requirements", label: "Requirements", type: "textarea", required: false, size: "col-12" },
                  ] 
                },
              ],
            }
          ],
        },
      ],
    },
    {
      title: "Applications",
      columns: [
        {
          size: "col-12",
          type: "tableRelation",
          name: "applications",
          entityName: "application",
        },
      ],
    }
  ],
};

export abstract class JobPostingData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<JobPosting[]>;
  abstract get(id: number): Observable<JobPosting>;
  abstract update(Book: JobPosting): Observable<JobPosting>;
  abstract create(JobPosting: JobPosting): Observable<JobPosting>;
  abstract delete(id: string): Observable<boolean>;
}
export abstract class Job_PostingData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<JobPosting[]>;
  abstract get(id: string): Observable<JobPosting>;
  abstract update(Job_Posting: JobPosting): Observable<JobPosting>;
  abstract create(Job_Posting: JobPosting): Observable<JobPosting>;
  abstract delete(id: string): Observable<boolean>;
  
}




